import { useState, useEffect } from 'react';
import { AbsenceForm } from './AbsenceForm';
import firebase from 'firebase/compat/app';

const functions = firebase.functions();

export function AbsenceDrawer({ isOpen, onClose, users, onSuccess, onError }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [absentUserId, setAbsentUserId] = useState('');
  
  // Default valid dates (today, and tomorrow for end date)
  const getTodayStr = () => new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(getTodayStr());
  
  const getTomorrowStr = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toISOString().split('T')[0];
  };
  const [endDate, setEndDate] = useState(getTomorrowStr());
  
  const [reassignments, setReassignments] = useState({}); // templateId -> interimUserId

  // Reset form when opened or user changed
  useEffect(() => {
    if (!isOpen) {
      // Small delay to allow drawer slide out animation
      setTimeout(() => {
        setAbsentUserId('');
        setStartDate(getTodayStr());
        setEndDate(getTomorrowStr());
        setReassignments({});
      }, 300);
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!absentUserId || !startDate || !endDate) {
      onError('Bitte fülle alle Pflichtfelder aus.');
      return;
    }
    
    if (endDate < startDate) {
      onError('Das Enddatum muss nach dem Startdatum liegen.');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const createAbsence = functions.httpsCallable('createAbsence');
      const result = await createAbsence({
        absentUserId,
        startDate,
        endDate,
        reassignments
      });
      
      onSuccess(result.data.message || 'Abwesenheit erfolgreich erfasst.');
      onClose();
    } catch (error) {
      onError('Fehler: ' + (error.message || 'Unbekannter Fehler'));
    } finally {
      setIsSubmitting(false);
    }
  };

  // Unmount completely if not open, freeing DOM and removing phantom pointer capture
  if (!isOpen && !isSubmitting) return null;

  return (
    <>
      <div className="absence-drawer-overlay" onClick={onClose} />
      <div className={`absence-drawer ${isOpen ? 'open' : ''}`}>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          
          <div className="drawer-header">
            <h3><i className="fas fa-plane-departure"></i> Abwesenheit erfassen</h3>
            <button type="button" className="close-drawer-btn" onClick={onClose} aria-label="Schließen">
              <i className="fas fa-times"></i>
            </button>
          </div>
          
          <div className="drawer-content">
            <AbsenceForm 
              absentUserId={absentUserId}
              onAbsentUserChange={setAbsentUserId}
              users={users}
              startDate={startDate}
              onStartDateChange={setStartDate}
              endDate={endDate}
              onEndDateChange={setEndDate}
              reassignments={reassignments}
              onReassignmentChange={setReassignments}
            />
          </div>
          
          <div className="drawer-footer">
            <button type="button" className="btn-secondary" onClick={onClose} disabled={isSubmitting}>
              Abbrechen
            </button>
            <button type="submit" className="btn-primary" disabled={isSubmitting || !absentUserId}>
              {isSubmitting ? (
                <><i className="fas fa-spinner fa-spin"></i> Speichern...</>
              ) : (
                <><i className="fas fa-save"></i> Abwesenheit starten</>
              )}
            </button>
          </div>

        </form>
      </div>
    </>
  );
}
